<template>
  <a :href="model.TargetUrl" class="widget">
    <div class="widget__title">{{ $res.Views.HomePage_Widget_WaitingForActivation }}</div>
    <div class="widget__body">
      <div class="widget__count"
           :class="{ 'widget__count_small': model.Count > 99 }">
        {{ model.Count }}
      </div>
      <div class="widget__content">
        <div class="widget__content-inner">
          {{ $tc("prebookingTextOnly", model.Count)}}
        </div>
        <div class="widget__icon">
          <svg width="36" height="36" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7172 9.0641L13.4576 8.86616C13.5019 8.5847 13.525 8.29548 13.525 8C13.525 7.70451 13.5019 7.41529 13.4576 7.13383L14.7172 6.93589C14.7717 7.28259 14.8 7.63799 14.8 8C14.8 8.362 14.7717 8.7174 14.7172 9.0641ZM14.35 5.56232L13.1598 6.01951C12.9505 5.47466 12.6569 4.9706 12.2944 4.5235L13.2848 3.72053C13.7303 4.2701 14.0919 4.89054 14.35 5.56232ZM12.2794 2.71519L11.4764 3.70557C11.0293 3.34308 10.5253 3.04949 9.98044 2.84019L10.4376 1.64998C11.1094 1.90803 11.7299 2.26961 12.2794 2.71519ZM9.06406 1.28277L8.86612 2.54231C8.58466 2.49808 8.29544 2.475 7.99995 2.475C7.70447 2.475 7.41525 2.49808 7.13379 2.54231L6.93584 1.28277C7.28255 1.22828 7.63795 1.2 7.99995 1.2C8.36196 1.2 8.71736 1.22828 9.06406 1.28277ZM5.56227 1.64998L6.01946 2.84019C5.47461 3.04949 4.97055 3.34308 4.52345 3.70557L3.72048 2.71519C4.27005 2.26961 4.8905 1.90803 5.56227 1.64998ZM2.71514 3.72053L3.70553 4.5235C3.34303 4.9706 3.04944 5.47466 2.84015 6.01951L1.64994 5.56232C1.90799 4.89054 2.26957 4.2701 2.71514 3.72053ZM1.28272 6.93589C1.22824 7.28259 1.19995 7.63799 1.19995 8C1.19995 8.362 1.22824 8.7174 1.28272 9.0641L2.54227 8.86616C2.49803 8.5847 2.47495 8.29548 2.47495 8C2.47495 7.70451 2.49803 7.41529 2.54227 7.13383L1.28272 6.93589ZM1.64994 10.4377L2.84015 9.98048C3.04944 10.5253 3.34303 11.0294 3.70553 11.4765L2.71515 12.2795C2.26957 11.7299 1.90799 11.1095 1.64994 10.4377ZM3.72048 13.2848L4.52345 12.2944C4.97055 12.6569 5.47461 12.9505 6.01947 13.1598L5.56227 14.35C4.8905 14.092 4.27005 13.7304 3.72048 13.2848ZM6.93584 14.7172L7.13379 13.4577C7.41525 13.5019 7.70447 13.525 7.99995 13.525C8.29544 13.525 8.58466 13.5019 8.86612 13.4577L9.06406 14.7172C8.71736 14.7717 8.36196 14.8 7.99995 14.8C7.63795 14.8 7.28255 14.7717 6.93584 14.7172ZM10.4376 14.35L9.98044 13.1598C10.5253 12.9505 11.0294 12.6569 11.4764 12.2944L12.2794 13.2848C11.7299 13.7304 11.1094 14.092 10.4376 14.35ZM13.2848 12.2795L12.2944 11.4765C12.6569 11.0294 12.9505 10.5253 13.1598 9.98048L14.35 10.4377C14.0919 11.1095 13.7303 11.7299 13.2848 12.2795ZM10.218 5.42671C10.0609 5.32386 9.85019 5.36785 9.74734 5.52495L7.59904 8.80657L6.43939 7.66559C6.30554 7.5339 6.09027 7.53564 5.95857 7.66949L5.54759 8.0872C5.4159 8.22105 5.41764 8.43632 5.55149 8.56802L7.2632 10.2522C7.47406 10.4596 7.79345 10.4892 8.03527 10.3424C8.13451 10.293 8.22235 10.2173 8.28747 10.1179L10.8302 6.23381C10.933 6.07671 10.889 5.86597 10.7319 5.76312L10.218 5.42671Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    model: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@use "./widget";

.widget__content {
  margin-top: 4px;
}
</style>


